import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = []

    update(event) {
        const checkbox = event.target
        if (!checkbox) return
        const badgeId = checkbox.dataset.badgeId
        if (!badgeId) return
        const badge = document.getElementById(badgeId)
        if (!badge) return
        const isOn = checkbox.checked
        badge.textContent = isOn ? "On" : "Off"
        badge.classList.toggle("bg-success", isOn)
        badge.classList.toggle("bg-secondary", !isOn)
    }
}

